var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 23,
    height: 23,
    rx: 4,
    fill: "#8800C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50195 11.2469C8.84619 9.75924 11.0762 8.77848 12.192 8.30462C15.3778 6.95167 16.0398 6.71664 16.4713 6.7088C16.5662 6.70718 16.7784 6.73119 16.9158 6.84506C17.0319 6.94121 17.0638 7.0711 17.0791 7.16226C17.0944 7.25343 17.1134 7.46109 17.0983 7.62336C16.9256 9.47546 16.1786 13.97 15.7986 16.0444C15.6378 16.9221 15.3211 17.2164 15.0146 17.2452C14.3484 17.3078 13.8425 16.7957 13.1973 16.3639C12.1876 15.6881 11.6172 15.2674 10.6372 14.608C9.50458 13.8459 10.2388 13.4271 10.8843 12.7426C11.0532 12.5634 13.9884 9.83748 14.0452 9.59019C14.0524 9.55927 14.0589 9.44398 13.9919 9.38311C13.9248 9.32224 13.8258 9.34305 13.7543 9.35961C13.6531 9.38308 12.0401 10.4716 8.91551 12.6252C8.45768 12.9461 8.04299 13.1025 7.67144 13.0943C7.26184 13.0853 6.47394 12.8579 5.88821 12.6635C5.16979 12.425 4.59881 12.299 4.64853 11.894C4.67442 11.6831 4.9589 11.4674 5.50195 11.2469Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.df9c3c58.svg";
export { ForwardRef as ReactComponent };